import useReviewMembers from './useReviewMembers';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL'; 
import MemberDataPage from '../Contents/Member/MemberDataPage';
import PersonIcon from '@mui/icons-material/Person';
/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const Verification = () => {

  

  const [Token,setToken] = useState(null)
  const {setLoader,accesstoken,RefreshUesFF,Person,Refresh,setRefresh} = useContext(ContextData)


  const {members: MemberData, loading: membersLoading, error: membersError, hasMore, fetchMore, reload} = useReviewMembers(Person?.acc_level, 1);

    const filteredMembers = useMemo(() => {
      return MemberData ? MemberData.filter(list => Number(list.acc_status) === 1) : [];
    }, [MemberData,Refresh]);

    const count = filteredMembers.length;

    const GetTokens = (token)=>{
       
      setToken(token)
     // console.log(Token)

    }


 


  return (
    <div  className="con-de" style={{width:"100%",height:"100%"}}>
   
     {/*  */}
      
     
         <div className=' w-full h-full flex '>


          <div className=' w-80 h-full flex flex-col justify-center items-center '>
                 <h2 className='bg-blue-950 w-full text-3xl text-white text-center font-extrabold h-10 mb-4'>Names</h2>
              <div style={{height:"50rem"}}  className='overflow-y-auto w-full'>

                    <ul className='cursor-pointer v-ul-list-p'>
                      {MemberData !== null && MemberData
                      .filter(list => Number(list.acc_status) === 1 && list.id_card_status === "0")
                      .map((list, index) => (
                      <li
                      key={index}
                      onClick={() => GetTokens(list.token)}
                      className="border-b-2 border-t-0 border-b-slate-100 border-t-slate-950 pt-3 pb-3 mt-2 pl-1 plr-1 relative"
                      style={{backgroundColor: list.token === Token && "green",color:list.token === Token && "white"}}
                      >
                      <li>{index + 1}</li>
                      <PersonIcon sx={{fontSize: "2em"}} />
                      <span>{list.fname} {list.lname}</span>
                       
                         {list.id_card_status === "0" && <span style={{color:'white',backgroundColor:"darkblue",padding:"3px", position:"absolute",right:5}}>{list.stateoforigin}</span>}
                        
                      </li>
                      ))}
                    </ul>{membersLoading&&<p role="status" style={{padding:12}}>Loading members…</p>}
 {membersError&&<div role="alert" style={{padding:12}}>{membersError}<button onClick={reload}>Retry</button></div>}
 {hasMore&&<button disabled={membersLoading} onClick={fetchMore} style={{margin:12,padding:8}}>Fetch more members</button>}
 {MemberData.length===0&&!membersLoading&&!membersError&&<p style={{padding:12}}>No members awaiting this stage.</p>}
 
              </div>
               
          </div>






          <div className='bg-slate-200 w-full h-full'>

          <h1 className='text-center text-3xl '>  <p className='font-extrabold  uppercase'>Verification</p></h1>
             <p className='pl-3'><b>Total submitted</b>: {count}</p>

              <div style={{height:"50rem"}} className='w-full overflow-y-auto'>
              <MemberDataPage token={Token} vr="vr"  />
              </div>

         </div>







         </div>
      
   
    </div>
  );
};

export default Verification;


// get_data_adminuser